import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { calculateAllowedRange, CalculateAllowedRange } from './calculate-allowed-range';

/** Fallback retention days when station.retentionDays is not set. */
export const STREAM_RETENTION_DAYS_DEFAULT = 7;

/**
 * Returns the allowed [from, to] range for the current station's stream time navigation.
 * - from: earliest allowed start of a stream range (start of day at now - retentionDays).
 * - to: upper bound — latest time that can be used as the start (from) of a stream range (now - 20 min).
 * Uses station.retentionDays; falls back to STREAM_RETENTION_DAYS_DEFAULT when not set.
 * Use in time-move controls to validate that:
 * - Move backwards does not navigate before range.from.
 * - Move forwards does not navigate past range.to.
 */
export function useStationStreamableRange(): CalculateAllowedRange {
  const station = useActiveStation();
  const now = Date.now();
  const retentionDays = station.retentionDays ?? STREAM_RETENTION_DAYS_DEFAULT;

  return calculateAllowedRange(now, {
    retentionDays,
    lookbackMs: 0,
  });
}
